import { FundStatus } from 'further-types/fund';

export const fundStatusOptions = [
  { value: FundStatus.Draft, label: 'Draft' },
  { value: FundStatus.Open, label: 'Open' },
  { value: FundStatus.Closed, label: 'Closed' },
];

export const getHiddenFundStatuses = (
  isCreating: boolean,
  hasInvestments: boolean,
): Array<FundStatus> => [
  ...(isCreating ? [FundStatus.Open, FundStatus.Closed] : []),
  ...(hasInvestments ? [FundStatus.Draft] : []),
];
